import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=2618d6f0&scoped=true&"
import script from "./Bank.vue?vue&type=script&lang=js&"
export * from "./Bank.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&id=2618d6f0&prod&scoped=true&lang=css&"
import style1 from "./Bank.vue?vue&type=style&index=1&id=2618d6f0&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2618d6f0",
  null
  
)

export default component.exports